import {useEffect, useState} from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { RiLineChartLine } from "react-icons/ri";
import api from "../../../../common/api";

ChartJS.register(ArcElement, Tooltip, Legend);
const Color = ["#095fbd", "#69a7e8", "#033f81"];

export default function LocationChart() {
  const [active, setActive] = useState(null);
  const [jobTypeChart, setJobTypeChart] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cities, setCities] = useState({});

  useEffect(() => {
    getCities();
  }, []);

  const getCities = async () => {
    try {
      setLoading(true);
      const res = await api.get("/planset/city_based_chart");
      setJobTypeChart(res.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Could not load data");
    } finally {
      setLoading(false);
    }
  };

  const entries = Object.entries(jobTypeChart);
  const hasData = entries.length > 0;
  const chartData = {
    labels: entries.map(([k]) => k),
    datasets: [{
        data: entries.map(([, v]) => v),
        backgroundColor: Color,
        borderColor: "#fff",
        borderWidth: 1,
        hoverBorderWidth: 3,
        hoverOffset: 10,
      }]};

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: { label: (ctx) => ` ${ctx.parsed}` },
        backgroundColor: "#0D0F1A",
        titleColor: "#F9FAFB",
        bodyColor: "#F9FAFB",
        padding: 14,
        cornerRadius: 10,
        borderWidth: 0,
        titleFont: { size: 11, weight: "600" },
        bodyFont: { size: 13, weight: "500" },
      },
    },
    onHover: (_, els) => setActive(els.length ? els[0].index : null),
  };

  return (
    <Card.Body>
      <Card.Title className="fw-bold mb-1 planset-title">Locations</Card.Title>
      <Card.Subtitle className="planset-subtitle mb-4">{loading ? "Loading..." : error ? "Could not load data" : `Location distribution`}</Card.Subtitle>
      {error ? <Alert variant="danger" className="mb-0">{error}</Alert>
       : loading ? <Row className="align-items-center justify-content-center m-0 planset-state-box"><Col xs="auto"><Spinner animation="border" size="sm" /></Col></Row>
       : !hasData ?
         <Row className="flex-column align-items-center justify-content-center m-0 text-center planset-state-box planset-no-data">
           <Col xs="auto"><RiLineChartLine size={20} /></Col>
           <Col xs="auto"><p className="mb-0 planset-no-data_title">No Data Available</p></Col>
           <Col xs="auto"><p className="mb-0">No records found</p></Col>
         </Row>
       : <Row className="align-items-center" style={{height:"300px",marginTop:"-1rem"}}>
          <Col xs={12} md={6} className="d-flex justify-content-center"><div className="planset-donut"><Pie data={chartData} options={options} /></div></Col>
          <Col xs={12} md={5}><div className="d-flex flex-column gap-2" style={{maxHeight:"320px", overflowY:"auto"}}>
              {entries.map(([key, value], i) => {
                const isActive = active === i;
                return (
                  <div key={key} className={`d-flex align-items-center gap-2 px-3 py-2 rounded-3 ${isActive ? "active cc-legend-item" : ""}`}>
                    <span className={`rounded-circle cc-dot ${isActive ? "active" : ""}`} style={{ background: Color[i % Color.length] }}/>
                    <span className={`flex-grow-1 cc-legend-label ${isActive ? "fw-semibold" : ""}`}>{key}</span>
                    <span className={`cc-legend-value ${isActive ? "fw-bold" : ""}`}>{value}</span>
                  </div>
                );
              })}
            </div>
          </Col>
         </Row>
      }
    </Card.Body>
  );
}